import React from 'react';
import styles from './SortDisplayControls.module.scss';
import type { DisplayValue, SortValue } from './useFilterSortDisplayForm';
import { Heading, RadioGroup, RadioButton } from 'components/core';
import { Stack } from 'components/layout';

const displayOptions: Record<DisplayValue, string> = {
  '25': '25 studies',
  '50': '50 studies',
  '100': '100 studies',
};

type Props = {
  sort: SortValue;
  display: DisplayValue;
  sortOptions: Record<string, string>;
  onSortChange: (sort: SortValue) => void;
  onDisplayChange: (display: DisplayValue) => void;
};

const SortDisplayControls = ({
  sort,
  display,
  sortOptions,
  onSortChange,
  onDisplayChange,
}: Props) => {
  const sortRadios = (Object.keys(sortOptions) as SortValue[]).map((key) => (
    <RadioButton
      size="sm"
      name={`sortBy[${key}]`}
      value={key}
      selectedValue={sort}
      onClick={() => onSortChange(key)}
      key={key}
      id={`sort-by-${key}`}
    >
      {sortOptions[key]}
    </RadioButton>
  ));

  const displayRadios = (Object.keys(displayOptions) as DisplayValue[]).map(
    (key) => (
      <RadioButton
        size="sm"
        name={`displayBy[${key}]`}
        value={key}
        selectedValue={display}
        onClick={() => onDisplayChange(key)}
        key={key}
        id={`display-by-${key}`}
      >
        {displayOptions[key]}
      </RadioButton>
    )
  );

  return (
    <Stack spacing={4}>
      <div>
        <fieldset className={styles.Fieldset}>
          <Heading
            type="h6"
            variant="brand"
            component="legend"
            className={styles.SortDisplayLegend}
          >
            Sort
          </Heading>
          <RadioGroup
            name="sortBy"
            defaultValue={sort}
            ariaLabel="Attribute to sort by"
            data-pendo-key="sort-options"
          >
            {sortRadios}
          </RadioGroup>
        </fieldset>
      </div>

      <div className={styles.SectionDivider} />

      <div>
        <fieldset className={styles.Fieldset}>
          <Heading
            type="h6"
            variant="brand"
            component="legend"
            className={styles.SortDisplayLegend}
          >
            Display
          </Heading>
          <RadioGroup
            name="displayBy"
            defaultValue={display}
            ariaLabel="Number of studies to display"
            data-pendo-key="display-options"
          >
            {displayRadios}
          </RadioGroup>
        </fieldset>
      </div>
    </Stack>
  );
};

export default SortDisplayControls;
